import {
  Policy,
  PolicyCancellation,
  Quote,
  UserLite,
} from '@lockton-apps/shared/interfaces';
import { createAction, props } from '@ngrx/store';

export enum DashboardBrokerDefaultActionTypes {
  Init = '[DashboardBrokerDefault Page] Initialise Broker Dashboard',
  PoliciesFilterChanged = '[DashboardBrokerDefault Page] Policies Filter Changed',
  FiltersChanged = '[DashboardBroker] Filters Changed',
  PolicyClicked = '[DashboardBroker Page] Policy Clicked',
  QuoteClicked = '[DashboardBroker Page] Quote Clicked',
  CancellationClicked = '[DashboardBroker Page] Cancellation Clicked',
  BrokerAssignedToQuote = '[DashboardBroker Page] Broker Assigned To Quote',
  SendInvite = '[DashboardBroker Page] Send Invite',
  ProposalReturned = '[DashboardBroker Page] Proposal Returned',
}

export const DashboardBrokerActions = {
  init: createAction(DashboardBrokerDefaultActionTypes.Init),
  policiesFilterChanged: createAction(
    DashboardBrokerDefaultActionTypes.PoliciesFilterChanged,
    props<{ filter: Record<string, any> }>()
  ),
  policyClicked: createAction(
    DashboardBrokerDefaultActionTypes.PolicyClicked,
    props<{ policy: Policy }>()
  ),
  quoteClicked: createAction(
    DashboardBrokerDefaultActionTypes.QuoteClicked,
    props<{ quote: Quote }>()
  ),
  cancellationClicked: createAction(
    DashboardBrokerDefaultActionTypes.CancellationClicked,
    props<{ cancellation: PolicyCancellation }>()
  ),
  filtersChanged: createAction(
    DashboardBrokerDefaultActionTypes.FiltersChanged,
    props<{ key: string; filter: Record<string, any> }>()
  ),

  brokerAssignedToQuote: createAction(
    DashboardBrokerDefaultActionTypes.BrokerAssignedToQuote,
    props<{ quoteId: number; user: UserLite | null }>()
  ),

  sendInvite: createAction(
    DashboardBrokerDefaultActionTypes.SendInvite,
    props<{ quote: Quote }>()
  ),
  proposalReturned: createAction(
    DashboardBrokerDefaultActionTypes.ProposalReturned,
    props<{ quote: Quote }>()
  ),
};
